import React from 'react'
import _ from 'lodash'
import I18n from '../lib/i18n'
import MultiLineTitle from './MultiLineTitle.js'
import formatCurrency from '../helpers/formatCurrency'
import ColorOptionLabel from './ColorOptionLabel'
import ProductStateLabel from './ProductStateLabel'
import AddToBagBtn from './AddToBagBtn'
import * as StyledComponent from '../styles'
import Config from '../configs'

const ProductDetail = (props, context) => {
  const { product_sku = {}, selected_color_option = {} } = props
  const { product = {}, not_allow_to_checkout } = product_sku
  const { id, sell_price: product_sell_price } = product
  const { swatch = {}, hex_value = '', name = '', sell_price: color_option_sell_price = '', stock_level } = selected_color_option

  const sell_price = color_option_sell_price || product_sell_price // original sell prices second

  // Handle hide variants
  const hide_color_option = _.includes(product.hide_variants, 'color_option')
  // const hide_size_option = _.includes(product.hide_variants, 'size_option')

  const add_to_bag_label = stock_level === 0 ? I18n.t('containers.product_search_result.out_of_stock') : I18n.t('containers.product_search_result.add_to_bag')
  const custom_label = _.get(selected_color_option, 'meta.custom_label')

  let params = {
    product,
    color_option_id: selected_color_option.id
  }

  return <StyledComponent.ProductDetail>
    <div className='product-name'>
      { Config.get('DEBUG') && `[${product_sku.code}]`}
      <MultiLineTitle title = {product.title} />
    </div>
    {
      !_.isEmpty(custom_label) &&
      <ProductStateLabel label={I18n.t(`labels.${custom_label}`)} />
    }
    {
      !hide_color_option && <div><ColorOptionLabel swatch={swatch} name={name} hex_value={hex_value} /></div>
    }
    {
      sell_price &&
        <div className='product-price' >HK{formatCurrency(sell_price)}</div>
    }
    <div>
      <AddToBagBtn
        product_id={id}
        addToBag={props.add_to_bag_loading ? null : props.addToBag.bind(this, params)}
        loading={props.add_to_bag_loading}
        loading_id={props.add_to_bag_loading_id}
        disabled={stock_level === 0 || not_allow_to_checkout}
        text={add_to_bag_label}
      />
    </div>
  </StyledComponent.ProductDetail>
}

ProductDetail.defaultProps = {
  product_sku: {},
  selected_color_option: {},
  addToBag: () => {}
}

export default ProductDetail



// WEBPACK FOOTER //
// ./src/components/ProductDetail.js